/* eslint-disable indent */
import React, { useEffect, useState } from 'react';
import { getIcon } from '@bvt-shared/utils/iconUtils';
import './DatexStepPOICheck.scss';

/**
 * @copyright PT Bhumi Varta Technology
 * @author Mochamad Riza Syarif<mochamad.riza@bvarta.com>
 */

/**
 * @description For data object
 * @typedef TsObjectPoiGroup
 * @type {Object}
 * @property {Array<object>} poi_group_list
 * @property {number} total_category
 * @property {number} total_brands
 * @property {number} total_criteria
 * @property {number} poi_matched
 */

/**
 * @description For data object
 * @typedef TStepDataObjectPoiAdj
 * @type {Object}
 * @property {number} province_id
 * @property {string} province_code
 * @property {string} province_name
 * @property {number} city_id
 * @property {string} city_code
 * @property {string} city_name
 * @property {number} district_id
 * @property {string} district_code
 * @property {string} district_name
 * @property {number} village_id
 * @property {string} village_code
 * @property {string} village_name
 * @property {object} checkedState
 * @property {Array<Object>} poi_brand
 * @property {Array<Object>} poi_criteria
 * @property {TsObjectPoiGroup} poi_group
 */

/**
 * @description Props Data
 * @param {object} props
 * @param {TStepDataObjectPoiAdj} props.data
 * @param {(isValid:boolean)=>void} props.onValidOrInvalid
 * @returns
 */
export const DatexStepPOICheck = (props) => {
  const { data, onValidOrInvalid } = props;
  const [sidebar, setSidebar] = useState(0);
  const [bodyHeight, setBodyHeight] = useState(0);

  const getClientHeight = (value) => {
    const docs = document.querySelector(value);
    return docs ? docs.clientHeight : 0;
  };
  const handleContentHeight = () => {
    const bodyHeight = getClientHeight(
      '.feature-map.LayoutDatexSidebarWrapper__body'
    );
    const content = getClientHeight('.DatexStepPOICheck__content_poiCheck');
    const header = getClientHeight('.DatexStepPOICheck__boxarea-poiCheck');
    const footer = getClientHeight('.DatexStepPOICheck__content_poiListfooter');
    const poi_list_content = getClientHeight(
      '.DatexStepPOICheck__content_poiList'
    );
    const contentBodyList =
      bodyHeight - content - poi_list_content - header - footer;

    setBodyHeight(contentBodyList);
    setSidebar(bodyHeight);
  };

  useEffect(() => {
    onValidOrInvalid(false);
  }, []);
  useEffect(() => {
    handleContentHeight();
    window.addEventListener('resize', handleContentHeight);
    return () => {
      window.removeEventListener('resize', handleContentHeight);
    };
  }, [sidebar]);
  return (
    <div className='DatexStepPOICheck'>
      <div
        className='DatexStepPOICheck__content_poiCheck'
        style={{ height: `${sidebar}px` }}
      >
        {/* Area Info */}
        <div className='DatexStepPOICheck__boxarea-poiCheck'>
          <span className='title-boxarea'>Area Info</span>
          <div className='subtitle-boxarea'>
            {(() => {
              const areaNames = [
                data?.province_name,
                data?.city_name,
                data?.district_name,
                data?.village_name,
              ].filter(Boolean);

              if (areaNames.length === 0) {
                return <span>Indonesia</span>;
              }

              return areaNames.map((name, idx) => (
                <span key={idx - name}>
                  {name}
                  {idx < areaNames.length - 1 && ','}
                </span>
              ));
            })()}
          </div>
        </div>
        {/* POI SELECTED */}
        {data?.poi_group?.poi_group_list &&
        data?.poi_group?.poi_group_list.length ? (
          <div
            className='DatexStepPOICheck__content_poiList'
            style={{ height: `${bodyHeight}px` }}
          >
            {data?.poi_group.poi_group_list.map((list) => {
              return (
                <div className='item-poiList' key={list.id}>
                  <div className='item-poiList_left'>
                    <img
                      alt={list.category_name}
                      height={24}
                      src={getIcon('poi', list.category_icon)}
                      width={24}
                    />
                    <span className='item-poiList_label'>
                      {list.category_name}
                    </span>
                  </div>
                  <div className='item-poiList_right'>
                    <div className='item-poiList_counting'>
                      <div className='item-poiList_label'>Brands</div>
                      <div className='item-poiList_value'>
                        {list.brandCount ?? 0}
                      </div>
                    </div>
                    <div className='item-poiList_counting'>
                      <div className='item-poiList_label'>Criteria</div>
                      <div className='item-poiList_value'>
                        {list.criteriaCount ?? 0}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          ''
        )}
        {/* FOOTER SUMMARY */}
        <div className='DatexStepPOICheck__content_poiListfooter'>
          <div className='item-poiList_footer'>
            <div className='item-poiList_footer_label'>Selected Items</div>
            <div className='item-poiList_footer_counting'>
              <div className='item-poiList_footer_counting_list'>
                <div className='item-poiList_footer_label'>Category</div>
                <div className='item-poiList_footer_value'>
                  {data?.poi_group.total_category}
                </div>
              </div>
              <div className='item-poiList_footer_counting_list'>
                <div className='item-poiList_footer_label'>Brands</div>
                <div className='item-poiList_footer_value'>
                  {data?.poi_group.total_brands}
                </div>
              </div>
              <div className='item-poiList_footer_counting_list'>
                <div className='item-poiList_footer_label'>Criteria</div>
                <div className='item-poiList_footer_value'>
                  {data?.poi_group.total_criteria}
                </div>
              </div>
            </div>
          </div>
          <div className='item-poiList_footer'>
            <div className='item-poiList_footer_label'>POI Matched</div>
            <div className='item-poiList_footer_label'>
              {data?.poi_group?.poi_matched ?? 0}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
